import { SiteID } from '../sites/models/site'

import axiosInstance from '../axiosInstance'
import { OnboardingDraft, OnboardingDraftData } from '../shared/api/generated/models'

const OnboardingEndpoints = {
  base: (siteId: SiteID) => `api/orgs/${siteId}/onboarding` as const,
  draft: (siteId: SiteID) =>
    `${OnboardingEndpoints.base(siteId)}/draft` as const,
  complete: (siteId: SiteID) =>
    `${OnboardingEndpoints.base(siteId)}/complete` as const,
}

export const loadDraft = async (
  siteId: SiteID,
): Promise<OnboardingDraft> => {
  const response = await axiosInstance.get(OnboardingEndpoints.draft(siteId))

  return {
    revision: response.data.revision,
    draft: response.data.draft as OnboardingDraftData,
    completed_at: response.data.completed_at,
  }
}

export const saveDraft = async (
  siteId: SiteID,
  revision: number,
  draft: OnboardingDraftData,
): Promise<OnboardingDraft> => {
  const response = await axiosInstance.put(
    OnboardingEndpoints.draft(siteId),
    { revision, draft: draft },
  )

  return {
    revision: response.data.revision,
    draft: response.data.draft as OnboardingDraftData,
    completed_at: response.data.completed_at,
  }
}

export const complete = async (siteId: SiteID, draft: OnboardingDraft): Promise<void> => {
  await axiosInstance.post(OnboardingEndpoints.complete(siteId), { draft: draft })
}
